// El menú en ocho módulos plegables · DIRECTRIZ-EXPERIENCIA E2
//
// MEDIDO EL 16 DE SEPTIEMBRE DE 2026: 55 opciones visibles a la vez, en
// 11 grupos, ninguno plegable. Aquí se decide cómo se pliega:
//
//   1. Los grupos que declaran los carriles se FUNDEN en ocho módulos
//      (MODULO_DE_GRUPO). Un carril sigue declarando su grupo de siempre:
//      esto solo decide bajo qué cabecera se enseña.
//   2. Cada módulo se abre o se cierra. Al entrar se abren: el del
//      módulo activo, los que la persona dejó abiertos (se recuerdan en su
//      navegador) y, por rol, los de ABIERTOS_POR_ROL.
//   3. Arriba, «Lo que más usas»: las cuatro pantallas que esa persona
//      abre más (se cuenta en su navegador, nunca en el servidor).
//   4. Lo apagado por módulo de la cuenta (nodo_modulo) no aparece:
//      MODULO_DE_CUENTA dice qué pantalla depende de qué módulo.
//
// Todo lo de aquí es puro: sin React y sin red, para poder probarlo.

export const ORDEN_MODULOS = [
  'Operación', 'Comercial', 'Compras y proveedores', 'Calidad y cumplimiento',
  'Vigilancia', 'Finanzas', 'Administración', 'Tu cuenta',
];

// Las pantallas de venta salen de Operación (28 opciones era demasiado
// para un solo módulo) y viven con Comercial: es donde las busca quien
// vende.
export const MODULO_DE_PANTALLA = {
  pos: 'Comercial', ventas: 'Comercial', facturas: 'Comercial', clientes: 'Comercial',
};

export const MODULO_DE_GRUPO = {
  'Operación': 'Operación',
  'Comercial': 'Comercial',
  'Compras y proveedores': 'Compras y proveedores',
  'Calidad': 'Calidad y cumplimiento',
  'Cumplimiento': 'Calidad y cumplimiento',
  'Vigilancia': 'Vigilancia',
  'Finanzas': 'Finanzas',
  'Control': 'Administración',
  'Planta y aparatos': 'Administración',
  'Administración': 'Administración',
  'Tu cuenta': 'Tu cuenta',
};

// MEDIDO TRAS EL PRIMER CORTE (16 sep 2026, 3.15.40): abrir Operación y
// Administración al dueño dejaba 52 opciones a la vez, que es casi lo de
// antes. Al entrar se abre UN módulo por rol; los demás están a un toque
// y se recuerdan.
export const ABIERTOS_POR_ROL = {
  DUENO: ['Operación'],
  ADMIN: ['Operación'],
  ENCARGADO: ['Operación'],
  OPERADOR: ['Operación'],
  CONSULTA: ['Operación'],
};

// Pantalla → módulo de la cuenta (los catorce de `perfil_modulo`). Lo que
// no está aquí no depende de ningún módulo y se enseña siempre.
export const MODULO_DE_CUENTA = {
  facturas: 'facturacion', facturacion: 'facturacion',
  clientes: 'cxc', 'finanzas-tu-dinero': 'cxp_bancos', 'finanzas-cuentas-por-pagar': 'cxp_bancos',
  'finanzas-bancos': 'cxp_bancos', 'finanzas-polizas': 'cxp_bancos',
  documentos: 'calidad', 'mis-lecturas': 'calidad', rastrear: 'calidad', inspecciones: 'calidad',
  'planes-inspeccion': 'calidad', 'no-conformidades': 'calidad', instrumentos: 'calidad',
  vencimientos: 'calidad', 'paquete-evidencia': 'calidad', invitados: 'calidad', 'calidad-ajustes': 'calidad',
  reclamos: 'reclamos',
  terminales: 'terminales', estacion: 'terminales', 'terminal-planta': 'terminales', 'terminal-baldas': 'terminales',
  'terminal-cuarentena': 'terminales', 'terminal-firmware': 'terminales', 'terminal-sugerencias': 'terminales',
  asistente: 'asistente', 'asistente-operativo': 'asistente',
  video: 'video',
  aprobaciones: 'autorizaciones', autorizaciones: 'autorizaciones',
  // EX-5 (1 oct 2026): las reglas viven con su bandeja. Si la cuenta no
  // tiene el módulo, se ven con su candado, igual que «Firmas pendientes».
  'accesos-reglas-de-autorizacion': 'autorizaciones',
  presencia: 'alcance',
};

const CLAVE_ABIERTOS = 'tego.menu.abiertos';
const CLAVE_USO = 'tego.menu.uso';
export const MAXIMO_MODULOS = 8;
export const MAXIMO_FRECUENTES = 4;

// =====================================================================
// ANEXO-CLIENTE-01 H-6 (20 sep 2026) · cada módulo, por uso real
// =====================================================================
// Administración con 22 entradas y Calidad y cumplimiento con 13 es más
// de lo que alguien explora. Cada módulo se ordena por lo que LA EMPRESA
// abre de verdad (contado en el servidor, `uso_de_pantalla`, sin
// persona) y, a igualdad, por lo que abre esta persona (su navegador).
// Lo que nadie ha abierto conserva el orden en que lo declaró su carril.
// Arriba quedan las MAXIMO_ARRIBA más usadas; la cola va detrás de «Más
// opciones». Si esconder dejaría UNA sola opción detrás, no se esconde:
// un pliegue para una entrada estorba más de lo que ahorra.
//
// LO QUE NO SE PLIEGA: los módulos que la cuenta no tiene por su plan
// (corona y diamante, L1-3) se ven SIEMPRE, con su marca, al final de la
// lista de arriba y nunca detrás de «Más opciones». Esto solo ordena y
// pliega lo que la empresa sí tiene y el rol sí puede usar.
export const MAXIMO_ARRIBA = 6;

/** Los items de un módulo ordenados por uso: empresa, luego persona, luego declarado. */
export function ordenarPorUso(items, usoEmpresa = {}, usoPersona = {}) {
  return items
    .map((m, i) => ({ m, i, e: usoEmpresa[m.id] || 0, p: usoPersona[m.id] || 0 }))
    .sort((a, b) => (b.e - a.e) || (b.p - a.p) || (a.i - b.i))
    .map((x) => x.m);
}

/** Qué va arriba y qué detrás de «Más opciones». `activa` nunca se esconde,
 *  y lo bloqueado por plan (con `bloqueo`) tampoco: va al final de arriba. */
export function partir(items, activa = null) {
  const bloqueados = items.filter((m) => m.bloqueo);
  const propios = items.filter((m) => !m.bloqueo);
  if (propios.length <= MAXIMO_ARRIBA + 1) return { arriba: propios.concat(bloqueados), mas: [] };
  const arriba = propios.slice(0, MAXIMO_ARRIBA).concat(bloqueados);
  const mas = propios.slice(MAXIMO_ARRIBA);
  return { arriba, mas, activaEscondida: mas.some((m) => m.id === activa) };
}

/** Los grupos de los carriles, fundidos en ≤ 8 módulos, cada módulo
 *  ordenado por uso (H-6) cuando se le pasa `uso`.
 *
 *  LO APAGADO SE VE, CON SU MARCA (DIRECTRIZ-LOOP L1-3, 20 sep 2026; antes,
 *  E2 lo escondía). Un módulo que la cuenta no tiene sigue en el menú:
 *  con CORONA si vive en un plan superior (y `bloqueo.plan` trae nombre y
 *  precio del catálogo), con DIAMANTE si se cotiza aparte, y con candado a
 *  secas si la nube apagó el módulo pero el catálogo no ha bajado. Es
 *  venta, no desorden: esconderlo era regalar la duda de si existía.
 *  `bloqueados` viene de `GET /api/experiencia/menu` (textos y precios
 *  del catálogo, nunca de aquí). */
export function agrupar(grupos, apagados = [], usoEmpresa = null, usoPersona = null, bloqueados = {}) {
  const fuera = new Set(apagados);
  const porModulo = new Map();
  for (const g of grupos) {
    const moduloDelGrupo = MODULO_DE_GRUPO[g.grupo] || 'Administración';
    for (const m of g.items) {
      const dep = MODULO_DE_CUENTA[m.id];
      const item = (dep && fuera.has(dep))
        ? { ...m, bloqueo: { modulo: dep, marca: 'candado', ...(bloqueados[dep] || {}) } }
        : m;
      const modulo = MODULO_DE_PANTALLA[m.id] || moduloDelGrupo;
      if (!porModulo.has(modulo)) porModulo.set(modulo, []);
      porModulo.get(modulo).push(item);
    }
  }
  const ordenar = (items) => (usoEmpresa || usoPersona
    ? ordenarPorUso(items, usoEmpresa || {}, usoPersona || {}) : items);
  return ORDEN_MODULOS
    .filter((n) => (porModulo.get(n) || []).length > 0)
    .map((n) => ({ modulo: n, items: ordenar(porModulo.get(n)) }))
    .slice(0, MAXIMO_MODULOS);
}

/** En qué módulo está una pantalla. */
export function moduloDe(modulos, id) {
  return (modulos.find((m) => m.items.some((i) => i.id === id)) || {}).modulo || null;
}

function leer(clave, omision) {
  try { const v = JSON.parse(localStorage.getItem(clave)); return v ?? omision; } catch { return omision; }
}
function guardar(clave, valor) {
  try { localStorage.setItem(clave, JSON.stringify(valor)); } catch { /* sin almacenamiento: vale para la sesión */ }
}

/** Qué módulos van abiertos: el activo + los recordados + los del rol. */
export function abiertosIniciales(rol, moduloActivo, recordados = leer(CLAVE_ABIERTOS, null)) {
  const base = recordados ?? (ABIERTOS_POR_ROL[rol] || ABIERTOS_POR_ROL.CONSULTA);
  const s = new Set(base);
  if (moduloActivo) s.add(moduloActivo);
  return s;
}

export function recordarAbiertos(abiertos) {
  guardar(CLAVE_ABIERTOS, [...abiertos]);
}

/** Cuenta una apertura de pantalla (para «Lo que más usas»). */
export function registrarUso(id, uso = leer(CLAVE_USO, {})) {
  const nuevo = { ...uso, [id]: (uso[id] || 0) + 1 };
  guardar(CLAVE_USO, nuevo);
  return nuevo;
}

/** Las N pantallas más abiertas que sigan existiendo en el menú, con ≥ 2 usos. */
export function masUsadas(modulos, uso = leer(CLAVE_USO, {}), n = MAXIMO_FRECUENTES) {
  const todas = new Map();
  for (const m of modulos) for (const i of m.items) todas.set(i.id, i);
  return Object.entries(uso)
    .filter(([id, veces]) => todas.has(id) && veces >= 2)
    .sort((a, b) => b[1] - a[1])
    .slice(0, n)
    .map(([id]) => todas.get(id));
}
